module.exports = __webpack_public_path__ + "static/media/questionThingy.3f5027ff.svg";